import { createStore, createStateHook, createActionsHook } from 'react-sweet-state';
import type {
	Action,
	BoundActions,
	HookActionsFunction,
	HookStateFunction,
	StoreActionApi,
} from 'react-sweet-state';

import type { ActiveContent } from '@atlassian/ai-audio';

type AudioButtonWrapperState = {
	activeContent: ActiveContent | null;
	eligibleForChangeboarding: boolean;
};

const initialState: AudioButtonWrapperState = {
	activeContent: null,
	eligibleForChangeboarding: false,
};

type AudioButtonWrapperActions = {
	setActiveContent: (
		activeContent: ActiveContent | null,
	) => Action<AudioButtonWrapperState, void, void>;
	setEligibleForChangeboarding: (
		eligibleForChangeboarding: boolean,
	) => Action<AudioButtonWrapperState, void, void>;
};

const actions: AudioButtonWrapperActions = {
	setActiveContent:
		(activeContent: ActiveContent | null) =>
		({ getState, setState }: StoreActionApi<AudioButtonWrapperState>) => {
			const state = getState();
			return setState({ ...state, activeContent });
		},
	setEligibleForChangeboarding:
		(eligibleForChangeboarding: boolean) =>
		({ getState, setState }: StoreActionApi<AudioButtonWrapperState>) => {
			const state = getState();
			return setState({ ...state, eligibleForChangeboarding });
		},
};

const AudioButtonWrapperStore = createStore<AudioButtonWrapperState, AudioButtonWrapperActions>({
	name: 'AudioButtonWrapperStore',
	initialState,
	actions,
});

export const useAudioButtonWrapperStore: HookStateFunction<
	{
		activeContent: ActiveContent | null;
		eligibleForChangeboarding: boolean;
	},
	void
> = createStateHook(AudioButtonWrapperStore, {
	selector: (state) => ({
		activeContent: state.activeContent,
		eligibleForChangeboarding: state.eligibleForChangeboarding,
	}),
});

export const useAudioButtonWrapperActions: HookActionsFunction<
	BoundActions<AudioButtonWrapperState, AudioButtonWrapperActions>
> = createActionsHook(AudioButtonWrapperStore);
